/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsDashboardsDetailsPageEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsDashboardsDetailsPageEntryPoint: EntryPoint<
	AssetsDashboardsDetailsPageEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDashboardsDetailsPageEntryPointComponent>(
		/* webpackChunkName: "async-assets-dashboards-details-entrypoint" */ './AssetsDashboardsDetails.tsx',
	),
	getPreloadProps: () => ({}),
});
